import { useMemo } from "react";
import PdfPage from "./base/PdfPage";
import PdfRow from "./base/PdfRow";
import PdfText from "./base/PdfText";
import PdfSection from "./base/PdfSection";
import PdfDivider from "./base/PdfDivider";
import PdfColumn from "./base/PdfColumn";
import { formatDate } from "../../../_src_shared/utils/functions/formatDate";
import PdfPageTitle from "./base/PdfPageTitle";
import PdfBuilderLogo from "./PdfBuilderLogo";
import PdfTitle from "./base/PdfPageTitle";
// import resilenderLogo from "../../../../assets/resilender-logo.png"; // Adjust the path as necessary
// import PdfColumn from "../components/layout/PdfColumn";
// import PdfDivider from "../components/layout/PdfDivider";
// import PdfRow from "../components/layout/PdfRow";
// import PdfSection from "../components/layout/PdfSection";
// import PdfPageTitle from "../components/typography/PdfPageTitle";
// import PdfText from "../components/typography/PdfText";
// import PdfBuilderLogo from "../ui/images/PdfBuilderLogo";
// import { pdfBuilderGetTypeValue } from "../utils/pdfBuilderGetTypeValue";
// import PdfPage from "./PdfPage";

const PdfPageBranded = ({
  children,
  pageNumber,
  subTitle,
  submittedBy,
  title,
  submittedDate,
  titleBadge,
  titleDescription,
  logo = true,
  footerDate,
  titleRightContent,
}) => (
  <PdfPage>
    {/* {(title || logo) && (
      <PdfRow
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          display: "flex",
          marginBottom: description ? 1 : 8,
        }}
      >
        <PdfColumn>
          {title && (
            <PdfTitle style={{ marginBottom: 0 }}>{title}</PdfTitle>
            // <PdfPageTitle style={{ marginBottom: 0 }}>{title}</PdfPageTitle>
          )}
          {description && (
            <PdfText
            // variant="small"
            // style={{
            //   color: "#666",
            //   lineHeight: 1.4,
            // }}
            >
              {description}
            </PdfText>
          )}
        </PdfColumn>
        <PdfTitle level="h3" subtitle="Additional context here">
          Section
        </PdfTitle>
        {logo && <PdfBuilderLogo width={85} />}

        
      </PdfRow>
    )} */}
    {(title || logo) && (
      <PdfPageTitle
        badge={titleBadge}
        subtitle={subTitle}
        description={titleDescription}
        rightContent={
          titleRightContent || logo ? <PdfBuilderLogo width={85} /> : null
        }
      >
        {title}
      </PdfPageTitle>
    )}

    {children}

    <PdfFooter>
      <PdfRow style={{ justifyContent: "space-between" }}>
        <FootSubmissionDetails
          submittedBy={submittedBy}
          footerDate={footerDate}
        />
        {pageNumber && <PdfText variant="small">Page {pageNumber}</PdfText>}
      </PdfRow>
    </PdfFooter>
  </PdfPage>
);
const PdfFooter = ({ children, style }) => {
  const styles = useMemo(() => {
    return {
      position: "absolute",
      bottom: -15,
      left: 0,
      width: "100%",
      padding: 20,
      color: "#666666",
      ...style,
    };
  }, [style]);
  return (
    <PdfSection style={styles}>
      <PdfDivider />
      {children}
    </PdfSection>
  );
};

const FootSubmissionDetails = ({ submittedBy, footerDate }) => {
  if (!submittedBy && !footerDate) {
    return null;
  }
  return (
    <PdfColumn>
      {footerDate && (
        <PdfText variant={"small"} style={{ marginBottom: 2 }}>
          Submitted: {formatDate(footerDate)}
        </PdfText>
      )}

      {submittedBy && (
        <PdfText variant={"small"}>Submitted By: {submittedBy}</PdfText>
      )}
    </PdfColumn>
  );
};

export default PdfPageBranded;
